import type { TOC } from '@ember/component/template-only';

import BarLoaderComponent from 'webapp/components/bar-loader';

const WizardLoadingRouteTemplate: TOC<object> = <template>
	<div id="loading">

		<div class="ct">
			<BarLoaderComponent @size="big" />
		</div>

	</div>
</template>;

export default WizardLoadingRouteTemplate;
